export default class SignupDomain {
  public idSignupDomain: number = 0;
  public domainName: string = "";
  public isAutoApproved: boolean = true;
  public idOrganization: number = 0;
}
